import classNames from 'classnames'
import { WizardStepProperties } from 'components/types'
import { ChangeEvent, useEffect, useRef, useState } from 'react'
import { CustomColorsRef, IconSizes } from 'types/general'

import IconRender from '../IconRender'

const NumberInput = ({
  name,
  label,
  value,
  required,
  isFirstInput,
  icon,
  onChange,
  setIsValid,
}: WizardStepProperties) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const [isFocused, setIsFocused] = useState(false)

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, type, value } = e.target

    if (value === '' || /^[0-9]*$/.test(value)) {
      setIsValid?.(value !== '')
      onChange({ name, type, value })
    }
  }

  const handleBlur = () => {
    setIsFocused(false)
  }

  const handleFocus = () => {
    setIsFocused(true)
  }

  useEffect(() => {
    if (isFirstInput && inputRef.current) {
      inputRef.current.focus()
    }
    if (!required) {
      setIsValid?.(true)
    }
  }, [required, isFirstInput])

  return (
    <div className="relative w-full">
      <label
        htmlFor={name}
        className="block text-imovSecondaryDark font-bold pl-1 mt-2 text-lg sm:text-base"
      >
        {label}
      </label>

      <div className="relative">
        {icon && (
          <span className="absolute left-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
            <IconRender
              icon={icon}
              size={IconSizes.LG}
              color={
                isFocused ? CustomColorsRef.PrimaryLight : CustomColorsRef.Gray
              }
            />
          </span>
        )}

        <input
          type="number"
          ref={inputRef}
          id={name}
          name={name}
          value={value as string}
          required={required}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          className={classNames(
            'w-full mb-2 p-2 border-2 border-imovGray rounded-md focus:outline-none focus:border-imovPrimaryLight text-lg sm:text-base',
            {
              'pl-10': icon,
            }
          )}
          min="0"
          step="1"
        />
      </div>
    </div>
  )
}

export default NumberInput
